import { useState, useCallback } from "react";
import { Prompt } from "@/lib/types";

export function usePromptDetail() {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const openPromptDetail = useCallback((prompt: Prompt) => {
    setSelectedPrompt(prompt);
    setIsOpen(true);
  }, []);

  const closePromptDetail = useCallback(() => {
    setIsOpen(false);
    // Delay clearing the prompt to allow exit animation
    setTimeout(() => setSelectedPrompt(null), 300);
  }, []);

  const updateSelectedPrompt = useCallback((updates: Partial<Prompt>) => {
    setSelectedPrompt((prev) => (prev ? { ...prev, ...updates } : null));
  }, []);

  return {
    selectedPrompt,
    isOpen,
    openPromptDetail,
    closePromptDetail,
    updateSelectedPrompt,
  };
}
